import {
  helpers,
  maxLength,
  minLength,
  numeric,
  required,
  requiredIf,
} from '@vuelidate/validators'
import { CertificatePaymentModel } from '../types'
import textErrors from '@/validation/textErrors'
import validators from '@/validation/validators'

export const FILE_FORMATS = ['jpeg', 'png', 'jpg', 'pdf']
export const MAX_FILES_SIZE = 15

export const MAX_FILES_COUNT = 20

export const MAX_DOCUMENT_NUMBER_LENGTH_TO_FNS_SENDING = 40

export const TYPE_GETTING_DOCUMENTS_OPTIONS = [
  {
    label: 'На e-mail',
    value: 'email',
  },
  {
    label: 'Отправить в ФНС в упрощенном порядке',
    value: 'taxService',
  },
]

export const TYPE_GETTING_DOCUMENTS_ALTERNATE_OPTIONS = [
  {
    label: 'На e-mail',
    value: 'email',
  },
]

export const REPORTING_YEARS = [0, 1, 2, 3].map((el) => {
  const getYearFromIndex = (i) =>
    new Date(new Date().setFullYear(new Date().getFullYear() - i))
      .getFullYear()
      .toString()
  return {
    name: getYearFromIndex(el),
    value: getYearFromIndex(el),
  }
})

export const getValidationRules = (insuranceModel: CertificatePaymentModel) => {
  const validateBirthCertificate =
    !insuranceModel.isInsured &&
    insuranceModel.insuredDocumentMode === 'birthCertificate'
  const validatePassport =
    !insuranceModel.isInsured &&
    insuranceModel.insuredDocumentMode === 'passport'
  return {
    previousRequest: {
      requiredIf: helpers.withMessage(
        textErrors.required,
        requiredIf(insuranceModel.isNotFirstRequest)
      ),
      prevRequest: helpers.withMessage(
        textErrors.previousRequest,
        helpers.regex(validators.vuelidatePreviousRequest())
      ),
    },
    serial: {
      required: helpers.withMessage(textErrors.required, required),
      maxLength: helpers.withMessage(textErrors.maxLength, maxLength(255)),
    },
    number: {
      required: helpers.withMessage(textErrors.required, required),
      maxLength: helpers.withMessage(textErrors.maxLength, maxLength(255)),
    },
    dateContract: {
      required: helpers.withMessage(textErrors.required, required),
      date: helpers.withMessage(
        textErrors.dateDDmmYYYY,
        helpers.regex(validators.vuelidateDateDDmmYYYY())
      ),
      maxDate: helpers.withMessage(textErrors.maxDate, (val: string) => {
        const [day, month, year] = val.split('.')
        return new Date(`${year}-${month}-${day}`) < new Date()
      }),
    },
    name: {
      required: helpers.withMessage(textErrors.required, required),
      cyrillic: helpers.withMessage(
        textErrors.cyrillicNew,
        helpers.regex(validators.vuelidateCyrillic())
      ),
    },
    surname: {
      required: helpers.withMessage(textErrors.required, required),
      cyrillic: helpers.withMessage(
        textErrors.cyrillicNew,
        helpers.regex(validators.vuelidateCyrillic())
      ),
    },
    patronymic: {
      requiredIf: helpers.withMessage(
        textErrors.required,
        requiredIf(insuranceModel.hasPatronymic)
      ),
      cyrillic: helpers.withMessage(
        textErrors.cyrillicNew,
        helpers.regex(validators.vuelidateCyrillic())
      ),
    },
    birthday: {
      required: helpers.withMessage(textErrors.required, required),
      date: helpers.withMessage(
        textErrors.dateDDmmYYYY,
        helpers.regex(validators.vuelidateDateDDmmYYYY())
      ),
      maxDate: helpers.withMessage(textErrors.maxDate, (val: string) => {
        const [day, month, year] = val.split('.')
        return new Date(`${year}-${month}-${day}`) < new Date()
      }),
    },
    inn: {
      required: helpers.withMessage(textErrors.required, required),
      minLength: helpers.withMessage(textErrors.innLength, minLength(12)),
    },
    passport: {
      required: helpers.withMessage(textErrors.required, required),
      passport: helpers.withMessage(
        textErrors.passportSeriesAndNumber,
        helpers.regex(validators.vuelidatePassportSeriesNumber())
      ),
    },
    passportDate: {
      required: helpers.withMessage(textErrors.required, required),
      date: helpers.withMessage(
        textErrors.dateDDmmYYYY,
        helpers.regex(validators.vuelidateDateDDmmYYYY())
      ),
      maxDate: helpers.withMessage(textErrors.maxDate, (val: string) => {
        const [day, month, year] = val.split('.')
        return new Date(`${year}-${month}-${day}`) < new Date()
      }),
    },
    email: {
      required: helpers.withMessage(textErrors.required, required),
      email: helpers.withMessage(
        'Неверный формат',
        validators.emailValidator()
      ),
    },
    phone: {
      required: helpers.withMessage(textErrors.required, required),
      minLength: helpers.withMessage(
        'Телефон должен содержать 11 цифр',
        minLength(18)
      ),
    },
    verificationCode: {
      required: helpers.withMessage(textErrors.required, required),
      minLength: helpers.withMessage(
        'Код должен содержать 4 цифры',
        minLength(4)
      ),
    },
    isEmailVerify: {
      checked: helpers.withMessage(
        textErrors.emailVerify,
        (value) => value === true
      ),
    },
    insuredName: {
      requiredIf: helpers.withMessage(
        textErrors.required,
        requiredIf(!insuranceModel.isInsured)
      ),
      cyrillic: helpers.withMessage(
        textErrors.cyrillicNew,
        helpers.regex(validators.vuelidateCyrillic())
      ),
    },
    insuredSurname: {
      requiredIf: helpers.withMessage(
        textErrors.required,
        requiredIf(!insuranceModel.isInsured)
      ),
      cyrillic: helpers.withMessage(
        textErrors.cyrillicNew,
        helpers.regex(validators.vuelidateCyrillic())
      ),
    },
    insuredPatronymic: {
      requiredIf: helpers.withMessage(
        textErrors.required,
        requiredIf(
          !insuranceModel.isInsured && insuranceModel.hasInsuredPatronymic
        )
      ),
      cyrillic: helpers.withMessage(
        textErrors.cyrillicNew,
        helpers.regex(validators.vuelidateCyrillic())
      ),
    },
    insuredBirthday: {
      requiredIf: helpers.withMessage(
        textErrors.required,
        requiredIf(!insuranceModel.isInsured)
      ),
      date: helpers.withMessage(
        textErrors.dateDDmmYYYY,
        helpers.regex(validators.vuelidateDateDDmmYYYY())
      ),
      maxDate: helpers.withMessage(textErrors.maxDate, (val: string) => {
        const [day, month, year] = val.split('.')
        return (
          !helpers.req(val) || new Date(`${year}-${month}-${day}`) < new Date()
        )
      }),
    },
    insuredInn: {
      minLength: helpers.withMessage(
        textErrors.innLength,
        minLength(12),
        requiredIf(insuranceModel.insuredInn.trim().length > 0)
      ),
    },
    insuredPassport: {
      requiredIf: helpers.withMessage(
        textErrors.required,
        requiredIf(validatePassport)
      ),
      passport: helpers.withMessage(
        textErrors.passportSeriesAndNumber,
        helpers.regex(validators.vuelidatePassportSeriesNumber())
      ),
    },
    insuredPassportDate: {
      requiredIf: helpers.withMessage(
        textErrors.required,
        requiredIf(validatePassport)
      ),
      date: helpers.withMessage(
        textErrors.dateDDmmYYYY,
        helpers.regex(validators.vuelidateDateDDmmYYYY())
      ),
      maxDate: helpers.withMessage(textErrors.maxDate, (val: string) => {
        const [day, month, year] = val.split('.')
        return (
          !helpers.req(val) || new Date(`${year}-${month}-${day}`) < new Date()
        )
      }),
    },
    insuredBirthCertificate: {
      requiredIf: helpers.withMessage(
        textErrors.required,
        requiredIf(validateBirthCertificate)
      ),
      birthCertificate: helpers.withMessage(
        textErrors.birthCertificate,
        (val: string) => {
          return !validateBirthCertificate || (val && val.length <= 25)
        }
      ),
    },
    insuredBirthCertificateDate: {
      requiredIf: helpers.withMessage(
        textErrors.required,
        requiredIf(validateBirthCertificate)
      ),
      date: helpers.withMessage(
        textErrors.dateDDmmYYYY,
        helpers.regex(validators.vuelidateDateDDmmYYYY())
      ),
      maxDate: helpers.withMessage(textErrors.maxDate, (val: string) => {
        const [day, month, year] = val.split('.')
        return (
          !helpers.req(val) || new Date(`${year}-${month}-${day}`) < new Date()
        )
      }),
    },
    documents: {
      required: helpers.withMessage(
        textErrors.requiredDocument,
        (value: File[]) => value.length > 0
      ),
      maxSize: helpers.withMessage(
        ({ $params }) => textErrors.maxFilesSize($params.size),
        validators.vuelidateFilesSize(MAX_FILES_SIZE)
      ),
      maxCount: helpers.withMessage(
        () => textErrors.maxFileCountGroup,
        maxLength(MAX_FILES_COUNT)
      ),
      formats: helpers.withMessage(({ $model }) => {
        const file = $model?.[0] as File
        return textErrors.fileFormat(
          ` .${/(?:\.([^.]+))?$/.exec(file.name)?.[1]}`
        )
      }, validators.validateFilesFormat(FILE_FORMATS)),
    },
    agreePrivacyData: {
      checked: helpers.withMessage(
        textErrors.required,
        (value) => value === true
      ),
    },
    typeGettingDocuments: {
      required: helpers.withMessage(textErrors.required, required),
    },
    reportingYear: {
      required: helpers.withMessage(textErrors.required, required),
    },
    amountPaidInsurance: {
      required: helpers.withMessage(textErrors.required, required),
      numeric: helpers.withMessage(textErrors.number, numeric),
      maxLength: helpers.withMessage(textErrors.maxLength, maxLength(255)),
    },
    countTaxRequests: {
      requiredIf: helpers.withMessage(
        textErrors.required,
        requiredIf(!insuranceModel.isFirstTaxRequest)
      ),
      numeric: helpers.withMessage(textErrors.number, numeric),
      maxLength: helpers.withMessage(textErrors.maxLength, maxLength(3)),
    },
    isFirstTaxRequest: true,
  }
}
